import { BrowserRouter as Router, Link, Route, Routes, useLocation } from "react-router-dom";

import { Home } from "@/pages/home";
import MenuPage from "@/pages/menu";
import { NotFound } from "@/pages/not-found";

import { Providers } from "./providers";

function Header() {
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname === path ? "text-primary" : "text-foreground/70 hover:text-foreground";
  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="inline-grid place-items-center h-8 w-8 rounded-md bg-secondary">
            <svg viewBox="0 0 64 64" className="h-5 w-5" aria-hidden>
              <path
                d="M48 28c0 12-12 22-16 22S16 44 16 32c0-8 6-14 14-14 8 0 18 4 18 10z"
                fill="currentColor"
              />
            </svg>
          </span>
          <span className="font-semibold">Sora Cha</span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          <Link to="/" className={isActive("/")}>
            Home
          </Link>
          <Link to="/menu" className={isActive("/menu")}>
            Menu
          </Link>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto max-w-6xl px-6 py-10 text-sm text-muted-foreground">
        © {new Date().getFullYear()} Sora Cha, Bangkok. All rights reserved.
      </div>
    </footer>
  );
}

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </Providers>
    </Router>
  );
}

export default AppRoutes;
